import { createStore, compose, applyMiddleware } from 'redux'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'
import reducer from './reducers'
import { loadingBarMiddleware } from 'react-redux-loading-bar'

export default function configureStore(initialState, isServer) {
  const logger = createLogger({
    predicate: (getState, action) => {
      return action.type !== 'HOLD_TIMER_TICK'
    }
  })

  const middleware = [thunk]

  if (!isServer) {
    middleware.push(
      logger,
      loadingBarMiddleware({
        promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAILURE']
      })
    )
  }

  if (!isServer && process.env.NODE_ENV !== 'production') {
    middleware.unshift(require('redux-immutable-state-invariant').default())
  }

  const store = createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      typeof window !== 'undefined' && window.devToolsExtension
        ? window.devToolsExtension({ trace: true })
        : f => f
    )
  )

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/redux/store.js